module.exports = __webpack_public_path__ + "static/infusionmax-59bba2602ab5ac0596321703d9afae98.jpeg";